import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { BidCloningCSS } from './BidCloningCSS.styled'
import { useLvgCloneBids } from 'hooks/games/lvg/useLvgCloneBids'
import { icons } from 'common'
import { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'
import { currencyFormatter } from 'utils'

export const BidCloning = () => {
  const { followees, followersData, isFollowersPending, getFollowers, isPending, unfollowUser, setFollowFees } =
    useLvgCloneBids()

  const stopFollowing = (parentAddress) => {
    unfollowUser(parentAddress)
  }

  useEffect(() => {
    getFollowers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [feePercentage, setFeePercentage] = useState()
  const setFee = (e) => {
    e.preventDefault()
    setFollowFees(feePercentage)
  }

  const handleFeeChange = (event) => {
    const value = event.target.value.replace(',', '.')
    if (!value) setFeePercentage()
    if (value > 5) {
      setFeePercentage(5)
      return
    }
    const amountRegEx = /^(\d+)(\.)?(\d{0,2})$/
    if (amountRegEx.test(value)) setFeePercentage(value)
  }
  return (
    <BidCloningCSS>
      <div className='user_tabs_panel' id='user-bc_panel'>
        <div className='content column'>
          <div className='subtitle alt'>
            Custom Fees
            <div className='total_fees_earned'>
              Total fees earned:{' '}
              <strong>{currencyFormatter(followersData?.totalFeesInfo?.totalFeesEarned || 0)}</strong>
            </div>
          </div>

          <form>
            <label htmlFor='clone_bid_max-amount'>
              Set a custom fee percentage for all users that clone your bids (Max 5%)
            </label>
            <fieldset>
              <input
                className='clone_bid_max-amount'
                id='clone_bid_max-amount'
                type='tel'
                placeholder={followersData?.totalFeesInfo?.parentFeeRateBp / 100 || '0.00'}
                value={feePercentage}
                onChange={handleFeeChange}
              />
              <button className='save' onClick={setFee}>
                Save
              </button>
            </fieldset>
          </form>
        </div>
        <div className='bc_panels_column'>
          <div className='content column'>
            <div className='subtitle alt'>Users cloning your bids</div>
            <SingleDataLoader
              loading={isFollowersPending}
              data={
                <div className='grid-content bid_cloning_list'>
                  {followersData?.followers.map((follower, idx) => (
                    <div key={`cloning-row-${idx}`} className='bid_cloning_table_row'>
                      <label className='title'>
                        <div className='user_avatar'>
                          <div className='avatar_image thirtytwo  '>
                            <img
                              className='avatar_image thirtytwo'
                              src={follower.avatar || icons.default_avatar_square}
                              alt=''
                            />
                          </div>
                        </div>
                        <div className='user_name'>{follower.username}</div>
                      </label>
                      <label className='value'></label>
                    </div>
                  ))}
                </div>
              }
            />
          </div>
          <div className='content column'>
            <div className='subtitle alt'>You are bid cloning</div>
            <SingleDataLoader
              loading={isPending === 'all'}
              data={
                <div className='grid-content bid_cloning_list'>
                  {followees.map((followee, idx) => (
                    <div key={`cloning-row2-${idx}`} className='bid_cloning_table_row'>
                      <label className='title'>
                        <div className='user_avatar'>
                          <div className='avatar_image thirtytwo bc '>
                            <img
                              className='avatar_image thirtytwo'
                              src={followee.avatar || icons.default_avatar_square}
                              alt=''
                            />
                          </div>
                        </div>
                        <div className='user_name'>
                          {followee.username}
                          <div className='user_subline'>
                            Open bids:{' '}
                            <strong>
                              {followee.openCount || 0} bids @ {currencyFormatter(followee.currentOpenAmount)}
                            </strong>
                          </div>
                        </div>
                      </label>
                      <label className='value'>
                        <SingleDataLoader
                          loading={isPending === followee.parentAddress}
                          data={
                            <button
                              className='remove_icon'
                              onClick={() => stopFollowing(followee.parentAddress)}
                            ></button>
                          }
                        />
                      </label>
                    </div>
                  ))}
                </div>
              }
            />
          </div>
        </div>
      </div>
    </BidCloningCSS>
  )
}
